import type { RealtimeUser } from "@/hooks/useCampaignRealtimeChannel";
import { getMapChromeTheme } from "@/components/mapChromeTheme";

interface OnlineUsersProps {
  users: RealtimeUser[];
  currentUserId?: string;
}

function getInitials(displayName: string): string {
  const parts = displayName.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0]![0]! + parts[1]![0]!).toUpperCase();
  }
  return displayName.slice(0, 2).toUpperCase();
}

export default function OnlineUsers({ users, currentUserId }: OnlineUsersProps) {
  const theme = getMapChromeTheme();
  const otherUsers = users.filter((u) => u.userId !== currentUserId);

  return (
    <div className="flex items-center gap-0.5" aria-label="Online users">
      {otherUsers.map((user) => (
        <div key={user.userId} className="group relative">
          <div
            className="flex h-7 w-7 items-center justify-center rounded-full border-2 border-transparent text-[10px] font-bold leading-none text-white"
            style={{
              backgroundColor: user.color,
            }}
            aria-label={user.displayName}
          >
            {getInitials(user.displayName)}
          </div>
          <div
            className={`pointer-events-none absolute left-1/2 top-full z-30 mt-1.5 -translate-x-1/2 whitespace-nowrap rounded px-2 py-1 text-[10px] font-medium opacity-0 transition-opacity group-hover:opacity-100 ${theme.tooltip}`}
          >
            {user.displayName}
            <span className="ml-1 text-[#fffaf1]/50">{user.role}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
